import { CompositeAsset } from "../decimal/common-types/manageAssets.ts";

export function bridgeAssetToCompositeAsset(
  exploreAsset: VST.Bridge.Asset
): CompositeAsset<"explore"> {
  return {
    manageAsset: {
      vbid: exploreAsset.vbid,
      title: exploreAsset.title,
      description: exploreAsset.description,
      author: exploreAsset.author,
      kind: exploreAsset.kind,
      edition: exploreAsset.edition,
      ancillaries: [],
      publisher: exploreAsset.publisher,
    },
    explore: exploreAsset,
  };
}
